import React, { useState, useRef, useEffect } from "react"
import moment from "moment"

// Branded month picker (replaces native <input type="month">). Value/onChange
// use the "YYYY-MM" string, matching the native input's contract.
const MwMonth = (props: any) => {
  const { value, onChange, min, placeholder = "Select month", disabled } = props
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const selected = value ? moment(value, "YYYY-MM") : null
  const minM = min ? moment(min, "YYYY-MM") : null
  const [viewYear, setViewYear] = useState<number>(
    selected ? selected.year() : moment().year()
  )
  const months = moment.monthsShort()

  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false)
    }
    document.addEventListener("mousedown", onDown)
    document.addEventListener("keydown", onKey)
    return () => {
      document.removeEventListener("mousedown", onDown)
      document.removeEventListener("keydown", onKey)
    }
  }, [open])

  const openPicker = () => {
    if (disabled) return
    if (selected) setViewYear(selected.year())
    setOpen(o => !o)
  }

  const minYear = minM ? minM.year() : null

  return (
    <div className={`mw-select mw-month ${open ? "show" : ""}`} ref={ref}>
      <button type="button" className="mw-select-toggle" disabled={disabled} onClick={openPicker}>
        <span className={selected ? "" : "mw-select-placeholder"}>
          {selected ? selected.format("MMMM, YYYY") : placeholder}
        </span>
        <i className="mdi mdi-calendar-month-outline" />
      </button>
      {open && (
        <div className="mw-select-menu mw-month-menu">
          <div className="mw-month-head">
            <button
              type="button"
              disabled={minYear != null && viewYear <= minYear}
              onClick={() => setViewYear(y => y - 1)}
            >
              <i className="mdi mdi-chevron-left" />
            </button>
            <span>{viewYear}</span>
            <button type="button" onClick={() => setViewYear(y => y + 1)}>
              <i className="mdi mdi-chevron-right" />
            </button>
          </div>
          <div className="mw-month-grid">
            {months.map((m, i) => {
              const mv = `${viewYear}-${String(i + 1).padStart(2, "0")}`
              const isSel = value === mv
              const isDisabled = !!(minM && moment(mv, "YYYY-MM").isBefore(minM, "month"))
              return (
                <button
                  type="button"
                  key={i}
                  disabled={isDisabled}
                  className={`mw-month-cell ${isSel ? "active" : ""}`}
                  onClick={() => {
                    onChange(mv)
                    setOpen(false)
                  }}
                >
                  {m}
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default MwMonth
